module.exports = __webpack_public_path__ + "img/timeline_miscevent-3.70b7cb34.jpg";